import { ADSENSE_CLIENT } from "./adsConfig";

let loadPromise: Promise<void> | null = null;

export function loadAdSense(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.__adsenseLoaded) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const start = () => {
      const s = document.createElement("script");
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
      s.onload = () => {
        window.__adsenseLoaded = true;
        resolve();
      };
      s.onerror = () => reject(new Error("AdSense load failed"));
      document.head.appendChild(s);
    };
    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(start, { timeout: 3000 });
    } else {
      setTimeout(start, 800);
    }
  });
  return loadPromise;
}
